import { PI2 } from '../../math';
import { ShapeLoop } from '../../shapes/ShapeLoop';
/**
 * Polygon shape
 *
 * @category Shapes.ShapeLoop
 * @class Polygon
 * @extends {ShapeLoop}
 */
class Polygon extends ShapeLoop {
    /**
     * Is based on ShapeLoop and you can pass `sideNumber` property to define
     * a number of sides.
     *
     * @param settings
     */
    constructor(settings = {}) {
        settings.type = settings.type || 'Polygon';
        settings.loopDependencies = (settings.loopDependencies || []).concat(['sideNumber']);
        super(settings, true);
        this.props.sideNumber = settings.sideNumber;
        this.loop = {
            start: 0,
            end: PI2,
            inc: (propArguments) => {
                return PI2 / this.getProp('sideNumber', propArguments, 5);
            },
            vertex: shapeLoopRepetition => {
                return [Math.cos(shapeLoopRepetition.current), Math.sin(shapeLoopRepetition.current)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
}
export { Polygon };
//# sourceMappingURL=Polygon.js.map